import { html } from '@design.estate/dees-element';

export const demoFunc = () => html`
  <style>
    .statusDemo {
      display: grid;
      gap: 16px;
      max-width: 520px;
      margin: 40px auto;
      padding: 24px;
      border-radius: var(--dees-radius-xl);
      background: var(--dees-color-bg-secondary);
    }
    .statusDemo .label {
      color: var(--dees-color-text-muted);
      font-size: 11px;
      text-transform: uppercase;
      letter-spacing: 0.05em;
    }
  </style>
  <div class="statusDemo">
    <div class="label">busy (default message)</div>
    <dees-harness-status .status=${{ type: 'busy' as const }}></dees-harness-status>
    <div class="label">busy with detail</div>
    <dees-harness-status
      .status=${{ type: 'busy' as const, message: 'Running tests — 3 of 12 files' }}
    ></dees-harness-status>
    <div class="label">error</div>
    <dees-harness-status
      .status=${{ type: 'error' as const, message: 'The model endpoint returned 429.' }}
    ></dees-harness-status>
    <div class="label">idle with showIdle</div>
    <dees-harness-status .status=${{ type: 'idle' as const }} showIdle></dees-harness-status>
  </div>
`;
